import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ATbutton from '@at.govt.nz/buttons';
import StopMap from './StopMap';
import MapWrapperContext from './MapWrapperContext';
import { ReactComponent as IconCloseBlack } from '../../../assets/svg/icon-close-black.svg';
import { ReactComponent as IcoCloseWhite } from '../../../assets/svg/icon-close-white.svg';
import ShapeOfTypes from '../../../utils/ShapeOfTypes';

const CloseButton = ({ onClose }) => (
  <div className="close">
    <ATbutton className="close__button close-button" onClick={onClose}>
      <span className="close-button__text">Close</span>
      <IcoCloseWhite className="close-button__icon close-button__icon--white" role="img" />
      <IconCloseBlack className="close-button__icon close-button__icon--black" role="img" />
    </ATbutton>
  </div>
);

const StopClusterMap = ({
  onClose, selectedAddress, selectStop, stops, enableAccessibilityOutlines,
}) => {
  const [map, setMap] = useState(null);
  const mapProvider = useMemo(() => ({ map, setMap }), [map, setMap]);
  return (
    <div className="stop-cluster-map">
      <CloseButton onClose={onClose} />
      <MapWrapperContext.Provider value={{ ...mapProvider }}>
        <StopMap {...{
          selectedAddress, selectStop, stops, enableAccessibilityOutlines,
        }}
        />
      </MapWrapperContext.Provider>
    </div>
  );
};

StopClusterMap.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedAddress: ShapeOfTypes.Address,
  selectStop: PropTypes.func.isRequired,
  stops: ShapeOfTypes.Stops,
};

StopClusterMap.defaultProps = {
  selectedAddress: null,
  stops: [],
};

export default StopClusterMap;